"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagAbIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagAbIcon = (0, _mobxReact.observer)(_class = (_FlagAbIcon = /*#__PURE__*/function (_React$Component) {
  function FlagAbIcon() {
    _classCallCheck(this, FlagAbIcon);
    return _callSuper(this, FlagAbIcon, arguments);
  }
  _inherits(FlagAbIcon, _React$Component);
  return _createClass(FlagAbIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M0 0h100v100H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#13AB5E",
        d: "M0 11h100v13H0zM0 37h100v13H0zM0 63h100v13H0zM0 87h100v13H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF5252",
        d: "M0 0h75.9v50H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M20.6 32.2L18 32l-.9-2.4-.9 2.4-2.6.2 2 1.6-.7 2.5 2.2-1.4 2.2 1.4-.7-2.5zM18.1 24.3l2.1-1.4 2.2 1.4-.7-2.5 2-1.6-2.5-.1-1-2.4-.9 2.4-2.5.1 2 1.6zM25.8 16l2.2-1.4 2.2 1.4-.7-2.5 2-1.6-2.6-.1-.9-2.4-.9 2.4-2.6.1 2 1.6zM37.1 12.6l2.1-1.4 2.2 1.4-.7-2.5 2-1.6-2.5-.2-1-2.4-.9 2.4-2.6.2 2 1.6zM48.7 15.8l2.2-1.4 2.1 1.4-.6-2.5 2-1.6-2.6-.1-.9-2.4-.9 2.4-2.6.1 2 1.6zM56.8 24.1l2.2-1.4 2.1 1.4-.7-2.5 2-1.6-2.5-.1-.9-2.4-1 2.4-2.5.1 2 1.6zM65.1 32.4l-2.6-.2-.9-2.4-.9 2.4-2.6.2 2 1.6-.7 2.5 2.2-1.4 2.1 1.4-.6-2.5z"
      }), /*#__PURE__*/_react["default"].createElement("ellipse", {
        fill: "#FFF",
        cx: "39.9",
        cy: "29",
        rx: "6.5",
        ry: "11.3"
      }))));
    }
  }]);
}(_react["default"].Component), _FlagAbIcon.defaultProps = {
  width: '20px'
}, _FlagAbIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagAbIcon);